import { useState } from "react";

import classNames from "classnames";
import { useFormikContext } from "formik";
import { Down, Up } from "neetoicons";
import { Label, Typography } from "neetoui";
import { Input, Switch } from "neetoui/formik";
import { not } from "ramda";
import { useTranslation } from "react-i18next";

import FormikDatePicker from "./FormikDatePicker";
import { isPastDate } from "./utils";

const AdvancedProperties = ({ showSendFromField, disableReplyTo }) => {
  const { t } = useTranslation();

  const { values } = useFormikContext();

  const [isAdvancedPropertiesVisible, setIsAdvancedPropertiesVisible] =
    useState(false);

  const toggleAdvancedOptions = () => setIsAdvancedPropertiesVisible(not);

  return (
    <div className="flex w-full flex-col items-start gap-4">
      <button
        className="flex w-full cursor-pointer items-start justify-between overflow-hidden border-0 py-4"
        type="button"
        onClick={toggleAdvancedOptions}
      >
        <Typography
          className="flex min-w-0 flex-grow"
          component="span"
          style="h5"
          weight="medium"
        >
          {t("neetoMolecules.shareViaEmail.advancedProperties")}
        </Typography>
        {isAdvancedPropertiesVisible ? (
          <Up className="flex-shrink-0" size={20} />
        ) : (
          <Down className="flex-shrink-0" size={20} />
        )}
      </button>
      {isAdvancedPropertiesVisible && (
        <>
          <div>
            <Label className="flex items-center gap-2">
              <Switch
                data-testid="send-later-switch"
                name="isSendLaterEnabled"
              />
              <Typography
                component="span"
                data-testid="send-later-label"
                lineHeight="normal"
                style="h4"
                weight="semibold"
              >
                {t("neetoMolecules.shareViaEmail.sendLater")}
              </Typography>
            </Label>
          </div>
          {values.isSendLaterEnabled && (
            <FormikDatePicker
              autoFocus
              data-testid="email-share-date-input"
              disabledDate={isPastDate}
              name="sendEmailDatetime"
              size="large"
            />
          )}
          <Input
            required
            className="w-full"
            label={t("neetoMolecules.shareViaEmail.startButtonText")}
            name="actionButtonText"
          />
          <div className="flex w-full flex-col gap-4 sm:flex-row sm:gap-6">
            {showSendFromField && (
              <Input
                required
                data-testid="neeto-molecules-share-via-email-send-from"
                label={t("neetoMolecules.shareViaEmail.sendFrom")}
                name="sendFromEmail"
                className={classNames({
                  "w-full flex-grow-0": !disableReplyTo,
                })}
              />
            )}
            {!disableReplyTo && (
              <Input
                required
                data-testid="replyTo-field"
                label={t("neetoMolecules.shareViaEmail.replyTo")}
                name="replyToEmail"
                className={classNames({
                  "w-full flex-grow-0": showSendFromField,
                })}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AdvancedProperties;
